import * as qs from 'qs';

import requestService from '../../../api/requestService';
import type { Event } from '../../../shared/types';
import type {
  User,
  UserDesktopFilters,
  CustomUserFilters,
  ProjectTaskDefaultFilters,
  DailyTaskDefaultFilters,
  GridSettings,
} from '../../../types';

type EventSettingsEntity = {
  id: number;
  user: User;
  event: Event;
  incidentGridSettings: GridSettings;
  pmpGridSettings: GridSettings;
  drsGridSettings: GridSettings;
  defaultDesktopFilters: UserDesktopFilters | null;
  customUserFilters: CustomUserFilters | null;
  dailyTaskDefaultFilter: DailyTaskDefaultFilters | null;
  projectTaskDefaultFilters: ProjectTaskDefaultFilters | null;
};

const updateQuery = qs.stringify({
  populate: ['incidentGridSettings', 'pmpGridSettings', 'drsGridSettings'],
});

export const eventSettingService = {
  create: (data: {
    user: EventSettingsEntity['user']['id'];
    event: EventSettingsEntity['event']['id'];
    defaultDesktopFilters?: EventSettingsEntity['defaultDesktopFilters'];
    incidentGridSettings?: EventSettingsEntity['incidentGridSettings'];
    pmpGridSettings?: EventSettingsEntity['pmpGridSettings'];
    drsGridSettings?: EventSettingsEntity['drsGridSettings'];
  }) => requestService.post<EventSettingsEntity>('/event-settings', { data }),
  update: ({
    id,
    ...data
  }: {
    id: EventSettingsEntity['id'];
    user?: EventSettingsEntity['user']['id'];
    event?: EventSettingsEntity['event']['id'];
    incidentGridSettings?: EventSettingsEntity['incidentGridSettings'];
    pmpGridSettings?: EventSettingsEntity['pmpGridSettings'];
    drsGridSettings?: EventSettingsEntity['drsGridSettings'];
    defaultDesktopFilters?: EventSettingsEntity['defaultDesktopFilters'];
    customUserFilters?: EventSettingsEntity['customUserFilters'];
    dailyTaskDefaultFilter?: EventSettingsEntity['dailyTaskDefaultFilter'];
    projectTaskDefaultFilters?: EventSettingsEntity['projectTaskDefaultFilters'];
  }) => requestService.put<{ data: EventSettingsEntity }>(`/event-settings/${id}?${updateQuery}`, { data }),
};
